import React from 'react';
import { themeGradient, useTheme } from '../../utils/ThemeContext';

// Fixed full-viewport gradient behind the page for the selected premium theme.
// Uses the theme from context unless one is passed explicitly.
const ThemeBackdrop = ({ theme: themeProp }) => {
    const { theme: contextTheme } = useTheme();
    const theme = themeProp || contextTheme;
    return (
        <div
            className="theme-backdrop"
            aria-hidden="true"
            style={{ background: themeGradient(theme) }}
        />
    );
};

export default ThemeBackdrop;
